module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret6-2560x1440.e8ec4d55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret6-2560x1440.jpg
// module id = 975
// module chunks = 37